import './App.css';
import TodoList from './Components/TodoList';

function App() {
  return (
    <div className="todo-app">
      <TodoList />
    </div>
  );
}

export default App;
